import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getAllCategorys, getFillterCategorys } from '../../redux/actions/category';
import { useStateContext } from '../../context/ContextProvider';
import { MealCategoryCard } from '../utils';
import { motion } from 'framer-motion';

function CategoriesSection() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentLang, currentDir } = useStateContext();
  const IsArabic = currentLang === "ar";
  const { isLoading, AllCategorys } = useSelector((state) => state.Categorys);

  useEffect(() => {
    // عرض جميع الفئات بدون pagination
    dispatch(getAllCategorys(1, 100));
  }, [dispatch]);


  return (
    <section className="py-20 md:py-28 bg-gradient-to-br from-color-1/5 via-transparent to-color-2/5">
        
      <div className="container">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <div className="flex justify-center mb-4">
            <div className="w-16 h-1 bg-color-1 rounded-full"></div>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl  font-kufi font-bold mb-4 bg-gradient-to-r from-color-1 to-color-2 bg-clip-text text-transparent pb-6">
            {t("Explore Our Categories")}
          </h2>
          <p className="text-gray-500 dark:text-gray-400 max-w-2xl mx-auto body-1">
            {t("Discover a variety of authentic Yemeni dishes, from traditional Mandi to delicious Madbi, prepared with love and expertise.")}
          </p>
          <div className="flex justify-center mt-4">
            <div className="w-20 h-1 bg-color-1/50 rounded-full"></div>
          </div>
        </motion.div>

        {/* Categories Grid - عرض جميع الفئات */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3  gap-6 md:gap-8">
          {AllCategorys?.map((category, index) => (
            <MealCategoryCard key={category._id || index} category={category} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default CategoriesSection;